<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M15.41 16.58 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42Z" />
  </svg>
</template>
